// @flow
import React, { Component } from 'react'
import AutoSizeTextArea from '../AutoSizeTextArea'
import LabeledWrapper from './LabeledWrapper'
import styled from 'styled-components'

export const StyledAutoSizeTextArea: typeof AutoSizeTextArea = styled(AutoSizeTextArea)`
  width: 480px;
  height: 40px;
  resize: vertical;

  &::placeholder {
    color: #aaa;
  }
`

type Props = {|
  htmlId: string,
  label: any,
  placeholder?: string,
  maxRows: number,
  maxLength?: number,
  value: string,
  errors?: Array<string>,
  onChange: (string) => void
|}

export default class AdditionalParamsTextArea extends Component<Props> {
  render() {
    const { htmlId, label, placeholder, maxRows, maxLength, value, errors, onChange } = this.props
    return (
      <LabeledWrapper label={label} errors={errors} twoLines>
        <StyledAutoSizeTextArea
          id={htmlId}
          className="input-item"
          placeholder={placeholder}
          value={value || ''}
          maxRows={maxRows}
          maxLength={maxLength}
          onChange={(event) => {
            onChange(event.target.value)
          }}
        />
      </LabeledWrapper>
    )
  }
}
